import { useTranslation } from 'react-i18next';

interface RightClickContextMenuProps {
  closeTabFn: () => void;
  closeTabStyles: React.CSSProperties | undefined;
  closeOtherTabsFn: () => void;
  closeAllTabsFn: () => void;
}

export const useRightClickContextMenu = ({
  closeTabFn,
  closeTabStyles,
  closeOtherTabsFn,
  closeAllTabsFn
}: RightClickContextMenuProps) => {
  const { t } = useTranslation('HbtMasterPoolDetails');

  const contextOptions = [
    {
      label: t('Master-Pool-Details-Close-Tab'),
      value: 'close',
      onClick: closeTabFn,
      customStyles: closeTabStyles
    },
    {
      label: t('Master-Pool-Details-Close-Other-Tabs'),
      value: 'closeOthers',
      onClick: closeOtherTabsFn
    },
    {
      label: t('Master-Pool-Details-Close-All-Tabs'),
      value: 'closeAll',
      onClick: closeAllTabsFn
    }
  ];

  return contextOptions;
};
